module.exports = __webpack_public_path__ + "static/media/SF_bm_engl_sentrert_logo_vestland_neg.caf64f2d.svg";